<template>
    <div class="user-testing-page" v-if="userData != null && contentVisible">
        <div class="container">
            <div class="vectorImg_13"><img :src="vectorImg_13" alt=""></div>
            <div class="booksPic"><img :src="booksPic" alt=""></div>
            <div class="ico_03"><img :src="ico_03" alt=""></div>
            <div class="ico_02"><img :src="ico_02" alt=""></div>
            <div class="ico_08"><img :src="ico_08" alt=""></div>
            <div class="logo-main"><img :src="logoMain" alt=""></div>
            <div class="page-title">
                <h1>{{ dictionaryLang.userTestingPage.title }}</h1>
                <p class="title-desc">{{ dictionaryLang.userTestingPage.title_desc }}</p>
                <div class="btn-not-today-container" v-if="curentIndex != 'complete_test'">
                    <button class="btn-not" @click="routeToAccount"><span>{{ dictionaryLang.userTestingPage.btn_nottoday }}</span></button>
                </div>
            </div>
            <div class="testing-container" v-if="curentIndex != 'complete_test'">
                <div class="testing-part" v-for="(item, partKey) in testList" v-if="partKey == curentIndex">
                    <div class="part-title-container">
                        <div class="part-name">{{ item.part_name }}</div>
                        <div class="part-title">
                            <strong v-if="globalLang == 'ru'">{{ item.part_title }}</strong>
                            <strong v-if="globalLang == 'kz'">{{ item.part_title_kz }}</strong>
                            <div class="ico_07"><img :src="ico_07" alt=""></div>
                        </div>
                    </div>
                    <div class="part-items">
                        <div class="item" v-for="(part, itemIndex) in item.part_items">
                            <div class="item-title"><strong v-if="globalLang == 'ru'">{{ part.quest_title }}</strong><strong v-else>{{ part.quest_title_kz }}</strong></div>
                            <div class="items-quests">
                                <div class="quest-radio" v-for="(option, optionIndex) in part.quest_vars" :key="optionIndex">
                                    <input type="radio" :id="`${partKey}_${itemIndex}_${optionIndex}`" :value="option.score" v-model="selectedOptions[partKey][itemIndex]" :checked="optionIndex === 0">
                                    <label :for="`${partKey}_${itemIndex}_${optionIndex}`"><span v-if="globalLang == 'ru'">{{ option.var_name }}</span><span v-else>{{ option.var_name_kz }}</span></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="testing-part" v-if="curentIndex == 'part_six'">
                    <div class="part-title-container">
                        <div class="part-name">ФИНАЛ</div>
                        <div class="part-title">
                            <strong v-if="globalLang == 'ru'">Выбор темы гайда</strong>
                            <strong v-if="globalLang == 'kz'">Гайд тақырыбын таңдау</strong>
                            <div class="ico_07"><img :src="ico_07" alt=""></div>
                        </div>
                    </div>
                    <div class="part-items">
                        <div class="item">
                            <div class="item-title"><strong v-if="globalLang == 'ru'">{{ part_six.part_items_title }}</strong><strong v-else>{{ part_six.part_items_title_kz }}</strong></div>
                            <div class="items-quests" v-if="selectedPartsFinal != null">
                                <div class="quest-radio" v-for="(option, optionIndex) in selectedPartsFinal" :key="optionIndex">
                                    <input type="radio" :id="option.key" :value="option" v-model="selectedOptionFinal">
                                    <label :for="option.key"><span v-if="globalLang == 'ru'">{{ option.title }}</span><span v-else>{{ option.title_kz }}</span></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn-get-result" @click="getFinalPartSix"><span>{{ dictionaryLang.userTestingPage.btn_final }}</span></button>
                    <!-- {{ selectedOptionFinal }} -->
                </div>
            </div>
            <div class="btn-next-part" v-if="curentIndex != 'complete_test'">
                <button class="btn-next" @click="nextPartSet" v-if="curentIndex == 'part_one' || curentIndex == 'part_two' || curentIndex == 'part_three' || curentIndex == 'part_four'"><span>{{ dictionaryLang.userTestingPage.btn_next }}</span></button>
                <!-- <button class="btn-next" @click="testEmailSend"><span>Тест EMAIL</span></button> -->
                <button class="btn-next" @click="getResultOfTesting" v-if="curentIndex == 'part_five'"><span>{{ dictionaryLang.userTestingPage.btn_final }}</span></button>
                <!-- {{ selectedOptions }} -->
            </div>
            <div class="complete-testing-msg" v-if="curentIndex == 'complete_test'">
                <strong>{{ dictionaryLang.userTestingPage.complete_msg_title }}</strong>
                <h5>{{ dictionaryLang.userTestingPage.complete_msg_desc }}</h5>
                <button class="btn-complete" @click="routeToAccount"><span>{{ dictionaryLang.userTestingPage.btn_complete }}</span></button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import { doc, setDoc, updateDoc } from "firebase/firestore"; 
    // import { collection, query, where, getDocs } from "firebase/firestore";
    export default {
        name: 'user-testing--page',
        components: {
        },
        data () {
            return {
                selectedOptions: {},
                selectedPartsFinal: {},
                selectedOptionFinal: {},
                averageScores: {},
                vebinarLink: 'https://youtube.com/live/liL-xc9mms8?feature=share',
                curentIndex: 'part_one',
                contentVisible: false,
                globalLang: window.GlobalLang, 
                logoMain: require('@/assets/images/logo-main.png'),
                vectorImg_13: require('@/assets/images/svg/vector-bg-13.svg'),
                vectorImg_11: require('@/assets/images/svg/vector-bg-11.svg'),
                booksPic: require('@/assets/images/books-pic-01.png'),
                ico_03: require('@/assets/images/ico_3_1.png'),
                ico_02: require('@/assets/images/ico_2.png'),
                ico_07: require('@/assets/images/ico_7_1.png'),
                ico_08: require('@/assets/images/ico_8.png'),
                part_six: {
                    part_items_title: 'Здравствуйте! Данный тест включает в себя несколько тем. Вы набрали равное количество баллов по некоторым из них. Пожалуйста, выберите интересующую вас тему?',
                    part_items_title_kz: 'Сәлеметсіз бе! Бұл тест бірнеше тақырыпты қамтиды. Сіз олардың кейбіреулері бойынша бірдей ұпай жинадыңыз. Сізді қызықтыратын тақырыпты таңдаңыз?',
                },
                testList: {
                    part_one: {
                        part_name: 'ЧАСТЬ 1',
                        part_title: 'Здоровое питание для ребенка',
                        part_title_kz: 'Балаға арналған салауатты тамақтану',
                        part_items: [
                            {
                                quest_title: 'Часто ли вашему ребёнку приходится посещать стоматолога для лечения кариеса?',
                                quest_title_kz: 'Сіздің балаңыз тіс жегісін емдеу үшін тіс дәрігеріне жиі барады ма?',
                                quest_vars: [
                                    {
                                        var_name: 'Раз в несколько месяцев.',
                                        var_name_kz: 'Бірнеше айда бір рет.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Раз в год.',
                                        var_name_kz: 'Жылына бір рет.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'В основном посещаем стоматолога для профилактического осмотра.',
                                        var_name_kz: 'Біз негізінен профилактикалық тексеру үшін тіс дәрігеріне барамыз.',
                                        score: 0,
                                    }
                                ]
                            },
                            {
                                quest_title: 'Как часто у ребенка бывает вздутие, несварение, запоры и другие проблемы с пищеварением?',
                                quest_title_kz: 'Баланың іш кебуі, ас қорытуы, іш қатуы және басқа ас қорыту проблемалары қаншалықты жиі кездеседі?',
                                quest_vars: [
                                    {
                                        var_name: 'Каждую неделю или чаще.',
                                        var_name_kz: 'Апта сайын немесе одан да көп.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Примерно раз в месяц или чуть реже.',
                                        var_name_kz: 'Айына бір рет немесе сәл аз.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Раз в полгода или реже.',
                                        var_name_kz: 'Жарты жылда бір рет немесе одан аз.',
                                        score: 0,
                                    }
                                ]
                            },
                            {
                                quest_title: 'Как часто в рационе вашей семьи появляются разнообразные овощи (кроме картофеля и кукурузы)?',
                                quest_title_kz: 'Әр түрлі көкөністер (картоп пен жүгеріден басқа) Сіздің отбасыңыздың диетасында қаншалықты жиі қолданылады?',
                                quest_vars: [
                                    {
                                        var_name: 'Едим овощи 1-2 раза в неделю, не чаще. Овощи не всегда входят в основные приемы пищи.',
                                        var_name_kz: 'Біз көкөністерді аптасына 1-2 рет жейміз, жиі емес. Көкөністер әрқашан негізгі тағамдарға кірмейді',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Едим часто, но не разнообразные (до 5 видов овощей). В основном одни и те же овощи на регулярной основе.',
                                        var_name_kz: 'Біз жиі жейміз, бірақ әр түрлі емес (көкөністердің 5 түріне дейін). Негізінен бірдей көкөністерді тұрақты негізде жейміз.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Едим 3-5 разных овощей ежедневно и следим за разнообразием в рационе: более 10 разных овощей и зелени в неделю.',
                                        var_name_kz: 'Біз күн сайын 3-5 түрлі көкөністерді жейміз және диетадағы әртүрлілікті бақылаймыз: аптасына 10-нан астам түрлі көкөністер мен шөптер.',
                                        score: 0,
                                    }
                                ]
                            }
                        ]
                    },
                    part_two: {
                        part_name: 'ЧАСТЬ 2',
                        part_title: 'Активность мозга, концентрация, память',
                        part_title_kz: 'Ми белсенділігі, шоғырлану, есте сақтау',
                        part_items: [
                            {
                                quest_title: 'Легко ли вашему ребёнку сохранять концентрацию до конца учебного дня?',
                                quest_title_kz: 'Балаңызға оқу күнінің соңына дейін зейінін сақтау оңай ма?',
                                quest_vars: [
                                    {
                                        var_name: 'Ребенок постоянно отвлекается на уроках, ему сложно сосредоточиться.',
                                        var_name_kz: 'Бала үнемі сабаққа алаңдайды, оған назар аудару қиын.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'К концу дня концентрация падает.',
                                        var_name_kz: 'Күннің соңына қарай зейіні төмендейді.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Ребенок сохраняет внимательность и активность до конца занятий.',
                                        var_name_kz: 'Бала сабақтың соңына дейін ұқыптылық пен белсенділікті сақтайды.',
                                        score: 0,
                                    }
                                ]
                            },
                            {
                                quest_title: 'Какие перекусы более популярны в вашей семье?',
                                quest_title_kz: 'Сіздің отбасыңызда қандай тағамдар көбірек танымал?',
                                quest_vars: [
                                    {
                                        var_name: 'Чипсы, сладости, творожные сырки, соки, печенье, йогурты с сахаром, фруктовые пюре и другие снэки.',
                                        var_name_kz: 'Чипсылар, тәттілер, сүзбе ірімшіктері, шырындар, печенье, қант қосылған йогурттар, жеміс пюресі және басқа да тағамдар.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Фрукты и фруктовые пюре, печенье из цельной муки, сытные бутерброды, фруктово-ореховые или злаковые батончики.',
                                        var_name_kz: 'Жемістер мен жеміс пюресі, тұтас ұннан жасалған печенье, дәмді бутербродтар, жеміс-жаңғақ немесе жарма батондары.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Орехи, семена, йогурты без сахара, овощные палочки, бутерброды с хлебом из цельного зерна, крекеры, иногда фруктово-ореховые батончики.',
                                        var_name_kz: 'Жаңғақтар, тұқымдар, қантсыз йогурттар, көкөніс таяқшалары, дәнді нан сэндвичтері, крекер, кейде жеміс-жаңғақ батондары.',
                                        score: 0,
                                    }
                                ]
                            },
                            {
                                quest_title: 'Как много времени ваш ребенок проводит за компьютером, телефоном, другими гаджетами или развлекательными журналами?',
                                quest_title_kz: 'Сіздің балаңыз компьютерде, телефонда, басқа гаджеттерде немесе ойын-сауық журналдарында қанша уақыт өткізеді?',
                                quest_vars: [
                                    {
                                        var_name: 'Ребенок использует гаджеты почти всё свободное время, ему сложно оторваться от них, чтобы заняться уроками, сделать домашние дела или прогуляться.',
                                        var_name_kz: 'Бала бос уақытының барлығын дерлік гаджеттерді пайдаланады, оларға сабақ алу, үй тапсырмасын орындау немесе серуендеу үшін олардан шығу қиынға соғады.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Ребенок охотно выполняет повседневные дела и необходимые задачи, но свободное время предпочитает проводить с гаджетами.',
                                        var_name_kz: 'Бала күнделікті іс-әрекеттерді және қажетті тапсырмаларды ықыласпен орындайды, бірақ бос уақытын гаджеттермен өткізуді жөн көреді.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'У ребенка разнообразные виды деятельности и развлечений, помимо гаджетов, он может играть в подвижные игры дома или на природе, охотно читает, занимается развивающими занятиями (пазлы, настольные игры или другие).',
                                        var_name_kz: 'Баланың әртүрлі іс-әрекеттері мен ойын-сауықтары бар, гаджеттерден басқа, ол үйде немесе табиғатта ашық ойындар ойнай алады, ықыласпен оқиды, дамытушылық іс-шаралармен айналысады (басқатырғыштар, үстел ойындары немесе басқалар).',
                                        score: 0,
                                    }
                                ]
                            }
                        ]
                    },
                    part_three: {
                        part_name: 'ЧАСТЬ 3',
                        part_title: 'Крепкий иммунитет',
                        part_title_kz: 'Мықты иммунитет',
                        part_items: [
                            {
                                quest_title: 'Каким способом был рождён ребёнок?',
                                quest_title_kz: 'Бала қандай жолмен дүниеге келді?',
                                quest_vars: [
                                    {
                                        var_name: 'Преждевременные роды (естественные или с помощью кесарева сечения).',
                                        var_name_kz: 'Мерзімінен бұрын босану (табиғи немесе кесар тілігі арқылы).',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Путем кесарева сечения, в срок.',
                                        var_name_kz: 'Кесарь тілігі арқылы, мерзімінде.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Естественные роды в срок.',
                                        var_name_kz: 'Мерзімінде табиғи босану.',
                                        score: 0,
                                    }
                                ]
                            },
                            {
                                quest_title: 'Часто ли ребёнок употребляет ферментированные продукты (квашеная капуста и другие овощи естественного брожения, кисломолочные продукты без сахара, чайный гриб и тому подобные)?',
                                quest_title_kz: 'Бала ашытылған тағамдарды жиі қолдана ма (қырыққабат және басқа да табиғи ашытылған көкөністер, қантсыз ашытылған сүт өнімдері, шай саңырауқұлағы және т. б.)',
                                quest_vars: [
                                    {
                                        var_name: 'Не ест совсем.',
                                        var_name_kz: 'Мүлдем жемейді',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Время от времени, в меню присутствуют в основном кисломолочные продукты.',
                                        var_name_kz: 'Анда-санда мәзірде негізінен ашытылған сүт өнімдері болады.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'На регулярной основе.',
                                        var_name_kz: 'Тұрақты негізде.',
                                        score: 0,
                                    }
                                ]
                            },
                            {
                                quest_title: 'Как часто ребенок болеет простудой?',
                                quest_title_kz: 'Балаға қаншалықты жиі суық тиеді?',
                                quest_vars: [
                                    {
                                        var_name: 'Раз в 2 месяца или чаще.',
                                        var_name_kz: '2 айда бір рет немесе одан да көп.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Примерно 1-2 раза в полгода.',
                                        var_name_kz: 'Жарты жылда шамамен 1-2 рет.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Примерно 1-2 раза в год или реже.',
                                        var_name_kz: 'Жылына шамамен 1-2 рет немесе одан аз.',
                                        score: 0,
                                    }
                                ]
                            }
                        ]
                    },
                    part_four: {
                        part_name: 'ЧАСТЬ 4',
                        part_title: 'Энергия и выносливость',
                        part_title_kz: 'Энергия және төзімділік',
                        part_items: [
                            {
                                quest_title: 'Какие напитки чаще всего пьет ваш ребенок?',
                                quest_title_kz: 'Сіздің балаңыз қандай сусындарды жиі ішеді?',
                                quest_vars: [
                                    {
                                        var_name: 'Молочные коктейли, газировку, пакетированные соки, сладкую детскую воду.',
                                        var_name_kz: 'Сүт коктейльдері, газды сусындар, оралған шырындар, тәтті нәресте суы.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Домашний морс или компот, свежевыжатый или качественный магазинный сок, какао или чай, часто с сахаром.',
                                        var_name_kz: 'Үйде дайындалған жеміс сусыны немесе компот, жаңа сығылған немесе сапалы дүкен шырыны, какао немесе шай, көбінесе қант қосылған.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Воду, детский чай без сахара, домашние ягодные напитки без сахара, воду, молочные напитки без сахара, чайный гриб/комбучу, овощные соки.',
                                        var_name_kz: 'Су, қантсыз балалар шайы, қантсыз үйдегі жидек сусындары, су, қантсыз сүт сусындары, шай саңырауқұлағы /комбуча, көкөніс шырындары.',
                                        score: 0,
                                    }
                                ]
                            },
                            {
                                quest_title: 'Быстро ли ваш ребенок устает от стандартной нагрузки?',
                                quest_title_kz: 'Сіздің балаңыз стандартты жүктемеден тез шаршай ма?',
                                quest_vars: [
                                    {
                                        var_name: 'Ребенок быстро устает от повседневных задач.',
                                        var_name_kz: 'Бала күнделікті тапсырмалардан тез шаршайды.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'В начале дня уровень энергии высокий, но ребенок быстро теряет энергию от нестандартной активности или в целом к концу дня.',
                                        var_name_kz: 'Күннің басында энергия деңгейі жоғары, бірақ бала стандартты емес белсенділіктен немесе жалпы күннің соңына дейін энергияны тез жоғалтады',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Ребенок в течение всего дня преимущественно энергичный и легко справляется с разными видами нагрузок.',
                                        var_name_kz: 'Бала күні бойы негізінен жігерлі және әртүрлі жүктемелермен оңай күреседі.',
                                        score: 0,
                                    }
                                ]
                            },
                            {
                                quest_title: 'Каков уровень физической активности у вашего ребенка?',
                                quest_title_kz: 'Сіздің балаңыздың физикалық белсенділік деңгейі қандай?',
                                quest_vars: [
                                    {
                                        var_name: 'Преимущественно сидячий образ жизни и уроки физкультуры в школе.',
                                        var_name_kz: 'Негізінен отырықшы өмір салты және мектептегі дене шынықтыру сабақтары.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Средний, присутствуют прогулки или спортивные секции несколько раз в неделю.',
                                        var_name_kz: 'Орташа, аптасына бірнеше рет серуендеу немесе спорт секциялары бар.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Прогулки каждый день, также есть зарядка или занятия спортом.',
                                        var_name_kz: 'Күн сайын серуендеу, сонымен қатар жаттығу немесе спортпен шұғылдану бар.',
                                        score: 0,
                                    }
                                ]
                            }
                        ]
                    },
                    part_five: {
                        part_name: 'ЧАСТЬ 5',
                        part_title: 'Настроение, радость, психоэмоциональное здоровье',
                        part_title_kz: 'Көңіл-күй, қуаныш, психоэмоционалды денсаулық',
                        part_items: [
                            {
                                quest_title: 'Есть ли у ребенка мотивация к учебе, стремление к изучению чего-то нового?',
                                quest_title_kz: 'Баланың оқуға деген ынтасы, жаңа нәрсені үйренуге деген ұмтылысы бар ма?',
                                quest_vars: [
                                    {
                                        var_name: 'Редко, в основном ребенок занят привычными развлечениями и гаджетами, нет усидчивости, учеба мало интересна.',
                                        var_name_kz: 'Сирек, негізінен бала әдеттегі ойын-сауық пен гаджеттермен айналысады, табандылық жоқ, оқу қызықты емес.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Интерес к учебе эпизодический, зависит от настроения, но ребенок с готовностью изучает что-то необычное, осваивает новые навыки.',
                                        var_name_kz: 'Оқуға деген қызығушылық эпизодтық, көңіл-күйге байланысты, бірақ бала әдеттен тыс нәрсені оңай үйренеді, жаңа дағдыларды үйренеді.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Ребенок хорошо мотивирован к учебе и получению знаний из разных областей, активно интересуется всем новым.',
                                        var_name_kz: 'Бала оқуға және әртүрлі салалардан білім алуға жақсы ынталы, барлық жаңа нәрселерге белсенді қызығушылық танытады.',
                                        score: 0,
                                    }
                                ]
                            },
                            {
                                quest_title: 'Насколько активно ваш ребенок вовлечен в социум, получает ли радость от общения со сверстниками?',
                                quest_title_kz: 'Сіздің балаңыз қоғамға қаншалықты белсенді қатысады, құрдастарымен қарым-қатынас жасау қуанышқа ие бола ма?',
                                quest_vars: [
                                    {
                                        var_name: 'Ребенок чаще сидит дома, в основном предпочитает общение в онлайн формате, мало друзей.',
                                        var_name_kz: 'Бала үйде жиі отырады, негізінен интернеттегі қарым-қатынасты жақсы көреді, достары аз.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'Небольшой круг друзей, но ребенок увлечен общением, проводит с ними много времени.',
                                        var_name_kz: 'Достардың шегі аз, бірақ бала қарым-қатынасқа құмар, олармен көп уақыт өткізеді.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Ребенок проводит много время с друзьями, активно строит новые социальные связи, всегда радуется возможности пообщаться со сверстниками.',
                                        var_name_kz: 'Бала достарымен көп уақыт өткізеді, жаңа әлеуметтік байланыстарды белсенді түрде дамытады, әрдайым құрдастарымен қарым-қатынас жасау мүмкіндігіне қуанады.',
                                        score: 0,
                                    }
                                ]
                            },
                            {
                                quest_title: 'Как часто у ребенка наблюдается плаксивость, капризность, раздражительность?',
                                quest_title_kz: 'Балада қаншалықты жиі жылау, түсіңкі көңіл-күй, ашуланшақтық бар?',
                                quest_vars: [
                                    {
                                        var_name: 'Ребенок часто бывает в подавленном настроении, много плачет или жалуется.',
                                        var_name_kz: 'Бала жиі депрессияға ұшырайды, көп жылайды немесе шағымданады.',
                                        score: 2,
                                    },
                                    {
                                        var_name: 'У ребенка часто меняется настроение, бывают эпизоды плаксивости и раздражительности.',
                                        var_name_kz: 'баланың көңіл-күйі жиі өзгереді, жылау мен ашуланшақтық эпизодтары болады.',
                                        score: 1,
                                    },
                                    {
                                        var_name: 'Очень редко.',
                                        var_name_kz: 'Өте сирек.',
                                        score: 0,
                                    }
                                ]
                            }
                        ]
                    },
                },
                partsListFinal: {
                    part_one: {
                        key: 'part_one',
                        title: 'Здоровое питание для ребенка',
                        title_kz: 'Балаға арналған салауатты тамақтану',
                        guide_ru: window.devUrl + 'guides/part_one/part_one_ru.pdf',
                        guide_kz: window.devUrl + 'guides/part_one/part_one_kz.pdf',
                    },
                    part_two: {
                        key: 'part_two',
                        title: 'Активность мозга, концентрация, память',
                        title_kz: 'Ми белсенділігі, шоғырлану, есте сақтау',
                        guide_ru: window.devUrl + 'guides/part_two/part_two_ru.pdf',
                        guide_kz: window.devUrl + 'guides/part_two/part_two_kz.pdf',
                    },
                    part_three: {
                        key: 'part_three',
                        title: 'Крепкий иммунитет',
                        title_kz: 'Мықты иммунитет',
                        guide_ru: window.devUrl + 'guides/part_three/part_three_ru.pdf',
                        guide_kz: window.devUrl + 'guides/part_three/part_three_kz.pdf',
                    },
                    part_four: {
                        key: 'part_four',
                        title: 'Энергия и выносливость',
                        title_kz: 'Энергия және төзімділік',
                        guide_ru: window.devUrl + 'guides/part_four/part_four_ru.pdf',
                        guide_kz: window.devUrl + 'guides/part_four/part_four_kz.pdf',
                    },
                    part_five: {
                        key: 'part_five',
                        title: 'Настроение, радость, психоэмоциональное здоровье',
                        title_kz: 'Көңіл-күй, қуаныш, психоэмоционалды денсаулық',
                        guide_ru: window.devUrl + 'guides/part_five/part_five_ru.pdf',
                        guide_kz: window.devUrl + 'guides/part_five/part_five_kz.pdf',
                    },
                },
                // starUser: require('@/assets/images/svg/star-user.svg'),
                // receptArrow: require('@/assets/images/svg/recept-arrow-01.svg'),
                // magnumRecept: require('@/assets/images/magnum-recept-01.png'),
            }
        },
        computed: mapGetters({
            dictionaryLang: 'loadDictionaryLang',
            isMobileChecker: 'loadIsMobileChecker',
            userData: 'loadUserDataStore',
        }),
        methods: {
            routeToAccount() {
                this.$router.push('/account');
            },
            nextPartSet() {
                 // Определяем следующий раздел в зависимости от текущего
                switch (this.curentIndex) {
                    case 'part_one':
                        this.curentIndex = 'part_two';
                        break;
                    case 'part_two':
                        this.curentIndex = 'part_three';
                        break;
                    case 'part_three':
                        this.curentIndex = 'part_four';
                        break;
                    case 'part_four':
                        this.curentIndex = 'part_five';
                        break;
                    case 'part_five':
                        // Если текущий раздел 'part_five', то переходим на 'part_one' (зацикливаемся)
                        this.curentIndex = 'part_one';
                        break;
                    default:
                        // Возможно, что-то еще, если нужно
                        break;
                }
                this.scrollTopInit();
                console.log('next')
            },
            getResultOfTesting() {
                // console.log(this.selectedOptions, 'selected');
                const arr = this.selectedOptions;
                const calculateAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
                // Объект для хранения средних значений по каждой части
                const averageScores = {};
                // Вычисляем среднее значение для каждой части
                for (let partKey in this.selectedOptions) {
                    const partValues = Object.values(this.selectedOptions[partKey]);
                    averageScores[partKey] = calculateAverage(partValues);
                }
                // console.log(averageScores);
                this.averageScores = averageScores;
                this.getFinalThem(averageScores);
                this.scrollTopInit();
            },
            getFinalThem(scoresArr) {
               // Находим максимальное среднее значение
                const maxScore = Math.max(...Object.values(scoresArr));
                // Находим объект или объекты с максимальным средним значением
                const maxScoreParts = {};
                for (let partKey in scoresArr) {
                    if (scoresArr[partKey] === maxScore) {
                        maxScoreParts[partKey] = maxScore;
                    }
                }
                // console.log("Максимальное среднее значение:", maxScore);
                // console.log(Object.keys(maxScoreParts).length)
                if (Object.keys(maxScoreParts).length > 1) { // Если средней бал равен нескольким этапам теста
                    for (let partKey in maxScoreParts) {
                        if (maxScoreParts[partKey] > 0) {
                            this.selectedPartsFinal[partKey] = this.partsListFinal[partKey];
                        }
                    }
                    this.selectedOptionFinal = Object.values(this.selectedPartsFinal)[0];
                    this.curentIndex = 'part_six';
                    // console.log('go to part 6');
                    // console.log(this.selectedPartsFinal, 'SELECETED THEMES FOR LAST SIX PART')
                } else { // если своершенно точно опередлена категория этапа согласно среднему балу
                    const partKey = Object.keys(maxScoreParts)[0];
                    if (this.partsListFinal.hasOwnProperty(partKey)) {
                        this.selectedPartsFinal = this.partsListFinal[partKey];
                    }

                    this.sendGuideOnEmail(this.selectedPartsFinal);
                    this.updateUserDB(this.selectedPartsFinal);
                    this.curentIndex = 'complete_test'
                    // console.log(this.selectedPartsFinal, 'SELECTED FINAL PART - 1 OBJECT');
                    // console.log('Lengt 1 -' ,maxScoreParts)
                }
                // console.log("Объекты с максимальным средним значением:", maxScoreParts); 
                // if (maxScoreParts.length > 1)
            },
            getFinalPartSix() {
                this.curentIndex = 'complete_test';
                this.sendGuideOnEmail(this.selectedOptionFinal);
                this.updateUserDB(this.selectedOptionFinal);
            },
            sendGuideOnEmail(finalOption) {
                var _self = this;
                var querystring = require('querystring');
                const postData = {
                    user_email : this.userData.user.email,
                    lang: this.globalLang,
                    name: this.userData.user.name,
                    sername: this.userData.user.sername,
                    vebinar_link: this.vebinarLink,
                    guide_link: finalOption.guide_ru,
                    subject: 'Ваш персональный гайд по здоровому питанию и регистрация на онлайн-вебинар 12 мая 2024 от Bonduelle®!'
                };
                if (this.globalLang == 'kz') {
                    postData.guide_link = finalOption.guide_kz;
                    postData.subject = 'Bonduelle® ұсынған 2024 жылғы 12 мамырдағы онлайн вебинарға тіркелу және дұрыс тамақтану бойынша жеке нұсқаулығыңыз!';
                }
                axios.post('https://bonduellepromo.kz/forms/guide-form.php', querystring.stringify(postData)).then(() => {
                    console.log('send complete')
                });
                console.log(finalOption, postData, '- POST DATA');
                // console.log('test-eemail', postData);
            },
            async updateUserDB(finalOption) {
                var _self = this;
                const currentDate = this.generateCurrentDate();
                const testResult = this.averageScores;
                const userRef = doc(this.$db, "users", this.$auth.currentUser.uid);
                await updateDoc(userRef, {
                    'user.online_test': true,
                    'testing': { 
                        'testResult_absolute': testResult,
                        'testLang': _self.globalLang,
                        'testResult_final' : {
                            'key': finalOption.key,
                            'title': finalOption.title,
                            'date_tested' : currentDate
                        }
                    },
                });
                // console.log(testResult)
                // console.log(finalOption)
                // console.log(userRef);
                // console.log(this.$auth.currentUser.uid);
            },
            generateCurrentDate() {
                const currentDate = new Date();
                const day = String(currentDate.getDate()).padStart(2, '0');
                const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
                const year = currentDate.getFullYear();
                const formattedDate = `${day}.${month}.${year}`;
                return formattedDate;
            },
            scrollTopInit() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // Добавляем плавную прокрутку
                });
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if (vm.userData != null) {
                    if (vm.userData.user.online_test) {
                        vm.$router.push('/');
                    } else {
                        vm.contentVisible = true;
                    }
                } else {
                    vm.$router.push('/');
                }
            });
        },
        beforeCreate() {
            document.body.dataset.page = 'user-testing';
        },
        created () {
            for (let partKey in this.testList) {
                this.$set(this.selectedOptions, partKey, {});
                for (let i = 0; i < this.testList[partKey].part_items.length; i++) {
                    // Установка начального значения в v-model для первого варианта ответа
                    this.$set(this.selectedOptions[partKey], i, this.testList[partKey].part_items[i].quest_vars[0].score);
                }
            }
        },
        mounted() {
        },
    }
</script>


<style lang="scss">
    @import '@/styles/components/account/user-testing-page.scss';
    @import '@/styles/components/account/user-testing-page-respond.scss';
    // @import '@/styles/components/account/account-page-respond.scss';
</style>